import React from "react";
import './ReferalStatisticPage.css';
import { NavLink } from "react-router-dom"
import TopPafeInfo from "../../Elements/BigElements/TopPageInfo/TopPafeInfo";
import ButtonStandart from "../../Elements/Buttons/ButtonStandart/ButtonStandart";
import {withAuth} from "../../withAuth";
import {withRouter} from "react-router-dom";
import {CopyToClipboard} from 'react-copy-to-clipboard';
import RefferalStatTable from "./RefferalStatTable";
import { referalLang } from "./referalLang";

class ReferalStatisticPage extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            hideNav : '',
            email: this.props.session.email,
            value: this.props.session.NicName !== null ? `${process.env.SITE_ADDRESS}/r/${this.props.session.NicName}` : 'link is temporarily unavailable',
            value2: this.props.session.NicName !== null ? `https://artyfact.game/?${this.props.session.NicName}` : 'link is temporarily unavailable',
            copied: false,
            copied2: false,
            Balance:  this.props.session.Balance,
            TableReferal:  this.props.session.TableReferal,
            usersAgent: this.props.UsersAgent,
            ModalInviteShow: false,
            Language: localStorage.getItem('language') ? localStorage.getItem('language') : 'en',
            inviteLink: this.props.session.NicName !== null ? `https://artyfact.game/invite/api-invite.php?emailfrom=${this.props.session.email}&namefrom=${this.props.session.Name} ${this.props.session.Surname}&invitelink=https://arno-token.com/?${this.props.session.NicName}` : ``
        }
    }

    componentDidMount() {
        window.addEventListener("resize", this.resize.bind(this));
        this.resize();
    }

    CloseModalInvite = event => {
        this.setState({ ModalInviteShow: false });
    }

    OpenModalInvite = event => {
        this.setState({ ModalInviteShow: true });
    }

    resize() {
        this.setState({hideNav: window.innerWidth <= 1100});
    }

    render(){
        let inviteIframe = `<iframe src="${this.state.inviteLink}" width="100%" style="min-height: 80vh; border: none;"></iframe>`;
        let refvalue = this.props.session.NicName !== null ? `https://artyfact.game/?${this.props.session.NicName}` : referalLang.unavailable[this.state.Language]
        return (
            <>

            <div className="ReferalStatisticPage ">
                <TopPafeInfo session={this.props.session} />

                <div className="ReferalPageTop ">                    
                    <div className="ReferalPageTopLink activeTab"><NavLink to='/referalstatistic' activeClassName="ReferalPageTopActiveLink">{referalLang.statistic[this.state.Language]}</NavLink></div>
                    <div className="ReferalPageTopLink"><NavLink to='/myguest' activeClassName="ReferalPageTopActiveLink">{referalLang.guest[this.state.Language]}</NavLink></div>
                </div>
                <div className="ReferalPageMain">

                <form>
                    <div className="ReferalStatisticPageMainIn ">
                        <div className="ReferalStatisticPageTitle">{referalLang.reflink[this.state.Language]}</div>
                        <label className="mt20px">
                            <div className="ReferalLinkArea">{this.state.value2}</div>
                            
                            {/*<input className="ReferalStatisticPageInput" type="text" value={this.state.value2} onChange={this.handleChange} placeholder="link is temporarily unavailable" disabled="disabled" />*/}
                            <div className="ReferalStatisticPageMainInButton" style={{ width: '50%' }}>
                                <CopyToClipboard text={this.state.value2} onCopy={() => this.setState({ copied2: true })}><span style={{display: 'inline-block'}}><ButtonStandart ssilka='#' classname='ButtonStandart' label={referalLang.copy2[this.state.Language]} /></span>
                                </CopyToClipboard>
                                {this.state.copied2 ? <span className="CopiedText" onClick={() => this.setState({ copied2: false })}>{referalLang.copy[this.state.Language]}</span> : null}
                                {/*<a className="ButtonStandart" style={{ display: this.props.session.NicName !== null ? 'inline-block' : 'none', cursor: 'pointer', margin: '0 10px' }} onClick={this.OpenModalInvite}>Send Invite</a>
                                <a className="ButtonStandartGray" style={{ display: this.props.session.NicName !== null ? 'none' : 'inline-block', margin: '0 10px' }}>Send Invite</a>*/}
                            </div>
                        </label>
                        <div class="alert-success">
                            {referalLang.info[this.state.Language]}
                        </div>
                        <div className="AlertRefferal" style={{ display: this.props.session.NicName !== null ? 'none' : 'block' }}>
                            <b>{referalLang.attention[this.state.Language]}</b> {referalLang.attention2[this.state.Language]} <a href={`${process.env.SITE_ADDRESS}/personal`}>{referalLang.attention3[this.state.Language]}</a> {referalLang.attention4[this.state.Language]}
                        </div>

                    </div>
                </form>
                    <div className="ReferalStatisticPageMainIn ReferalStatisticPageMainComp">

                        <div className="ReferalStatisticPageTable">
                            <div className="ReferalStatisticPageTitle">{referalLang.refgroup[this.state.Language]}</div>
                        </div>
                        <RefferalStatTable session={this.props.session}/>
                    </div>
                </div>
            </div>

            <div className="Modal" style={{ display: this.state.ModalInviteShow ? 'block' : 'none' }}>
                <div class="Modal-dialog" style={{ 'max-width': '600px' }}>
                    <div className="Modal-content">
                        <div className="Modal-header">
                            <div className="closeModal" style={{ right: '-15px' }} onClick={this.CloseModalInvite}>×</div>
                            {/*Invite to ARNO Token Project*/}
                        </div>
                        <div className="Modal-body">
                            <div dangerouslySetInnerHTML={ {__html: inviteIframe} } />                                            
                        </div>
                    </div>
                </div>
            </div>

            </>
        )}}

export default withAuth(session => session && session)(withRouter(ReferalStatisticPage));